export interface Member {
	id: string;
	user: string;
	firstname: string;
	lastname: string;
	meta?:  Record<string, any>;
	description?: string;
	active?: string;
	disabled?: string;
	email?: string;
	phone?: string;
	city?: string;
	address1?: string;
	address2?: string;
	state?: string;
	country?: string;
	postalcode?: string;
	birthdate?: string;
	created?: string;
	lastlogin?: string;
	website?: string;
	publicfiles?: number;
	unmoderatedfiles?: number;
	deniedfiles?: number;
	approvedfiles?: number;
	friends?: number;
	followers?: number;
	following?: number;
	permissions?: Record<string, string[]>;
}

export const defaultUserInfo: Member = {
		id: '',
		user: '',
		firstname: '',
		lastname: '',
		meta: {},
		description: '',
		active: '',
		disabled: '',
		email: '',
		phone: '',
		city: '',
		address1: '',
		address2: '',
		state: '',
		country: '',
		postalcode: '',
		birthdate: '',
		created: '',
		lastlogin: '',
		website: '',
		publicfiles: 0,
		unmoderatedfiles: 0,
		deniedfiles: 0,
		approvedfiles: 0,
		friends: 0,
		followers: 0,
		following: 0,
		permissions: {}
}
